export default {
    // Shapes
    circle: {unlocked: true, icon: 'mdi-circle', color: 'orange'},
    rectangle: {icon: 'mdi-rectangle', color: 'indigo'},
    triangle: {icon: 'mdi-triangle', color: 'light-green'},
    star: {icon: 'mdi-star', color: 'amber'},
    ellipse: {icon: 'mdi-ellipse', color: 'purple'},
    heart: {icon: 'mdi-heart', color: 'red'},
    square: {icon: 'mdi-square', color: 'light-blue'},
    octagon: {icon: 'mdi-octagon', color: 'babypink'},
    pentagon: {icon: 'mdi-pentagon', color: 'aqua'},
    hexagon: {icon: 'mdi-hexagon', color: 'brown'},

    // Special
    bomb: {isSpecial: true, icon: 'mdi-bomb', color: 'pale-red'},
    dice: {isSpecial: true, icon: 'mdi-dice-multiple', color: 'pale-pink'},
    accelerator: {isSpecial: true, icon: 'mdi-rotate-orbit', color: 'pale-purple'},
    sparkles: {isSpecial: true, icon: 'mdi-shimmer', color: 'pale-green'},
    hourglass: {isSpecial: true, icon: 'mdi-timer-sand', color: 'pale-yellow'},
    chest: {isSpecial: true, icon: 'mdi-treasure-chest', color: 'pale-blue'},
}
